// File#: _1_immersive-section-transition
// Usage: codyhouse.co/license
(function() {
    var ImmerseSectionTr = function(element) {
      this.element = element;
      this.media = this.element.getElementsByClassName('js-immerse-section-tr__media');
      this.scrollContent = this.element.getElementsByClassName('js-immerse-section-tr__content');
      if(this.media.length < 1) return;
      this.figure = this.media[0].getElementsByClassName('js-immerse-section-tr__figure');
      if(this.figure.length < 1) return;
      this.visibleFigure = false;
      this.mediaScale = 1;
      this.mediaInitHeight = 0;
      this.elementPadding = 0;
      this.scrollingFn = false;
      this.scrolling = false;
      this.active = false;
      this.scrollDelta = 0; // amount to scroll for full-screen scaleup
      initImmerseSectionTr(this);
    };
  
    function initImmerseSectionTr(element) {
      initContainer(element);
      resetSection(element);
  
      // listen to resize event and reset values
      element.element.addEventListener('update-immerse-section', function(event){
        resetSection(element);
      });
  
      // detect when the element is sticky - update scale value and opacity layer 
      var observer = new IntersectionObserver(immerseSectionTrCallback.bind(element));
      observer.observe(element.media[0]);
    };
  
    function resetSection(element) {
      getVisibleFigure(element);
      checkEffectActive(element);
      if(element.active) {
        Util.removeClass(element.element, 'immerse-section-tr--disabled');
        updateMediaHeight(element);
        getMediaScale(element); 
        updateMargin(element);
        setScaleValue.bind(element)();
      } else {
        // reset appearance
        Util.addClass(element.element, 'immerse-section-tr--disabled');
        element.media[0].style = '';
        element.scrollContent[0].style = '';
        updateScale(element, 1);
        updateOpacity(element, 0);
      }
      element.element.dispatchEvent(new CustomEvent('immersive-section-updated', {detail: {active: element.active, asset: element.visibleFigure}}));
    };
  
    function getVisibleFigure(element) { // get visible figure element
      element.visibleFigure = false;
      for(var i = 0; i < element.figure.length; i++) {
        if(window.getComputedStyle(element.figure[i]).getPropertyValue('display') != 'none') {
          element.visibleFigure = element.figure[i];
          break;
        }
      }
    };
  
    function updateMediaHeight(element) { // set sticky element padding/margin + height
      element.mediaInitHeight = element.visibleFigure.offsetHeight;
      element.scrollDelta = (window.innerHeight - element.visibleFigure.offsetHeight) > (window.innerWidth - element.visibleFigure.offsetWidth)
        ? (window.innerHeight - element.visibleFigure.offsetHeight)/2
        : (window.innerWidth - element.visibleFigure.offsetWidth)/2;
      if(element.scrollDelta > window.innerHeight) element.scrollDelta = window.innerHeight;
      if(element.scrollDelta < 200) element.scrollDelta = 200;
      element.media[0].style.height = window.innerHeight+'px';
      element.media[0].style.paddingTop = (window.innerHeight - element.visibleFigure.offsetHeight)/2+'px';
      element.media[0].style.marginTop = (element.visibleFigure.offsetHeight - window.innerHeight)/2+'px';
    };
  
    function getMediaScale(element) { // get media final scale value
      var scaleX = roundValue(window.innerWidth/element.visibleFigure.offsetWidth),
        scaleY = roundValue(window.innerHeight/element.visibleFigure.offsetHeight);
  
      element.mediaScale = Math.max(scaleX, scaleY);
      element.elementPadding = parseInt(window.getComputedStyle(element.element).getPropertyValue('padding-top'));
    };
  
    function roundValue(value) {
      return (Math.ceil(value*100)/100).toFixed(2);
    };
  
    function updateMargin(element) { // update distance between media and content elements
      if(element.scrollContent.length > 0) element.scrollContent[0].style.marginTop = element.scrollDelta+'px';
    };
  
    function setScaleValue() { // update asset scale value
      if(!this.active) return; // effect is not active
      var offsetTop = (window.innerHeight - this.mediaInitHeight)/2;
      var top = this.element.getBoundingClientRect().top + this.elementPadding;
  
      if( top < offsetTop && top > offsetTop - this.scrollDelta) {
        var scale = 1 + (top - offsetTop)*(1 - this.mediaScale)/this.scrollDelta;
        updateScale(this, scale);
        updateOpacity(this, 0);
      } else if(top >= offsetTop) {
        updateScale(this, 1);
        updateOpacity(this, 0);
      } else {
        updateScale(this, this.mediaScale);
        updateOpacity(this, 1.8*( offsetTop - this.scrollDelta - top)/ window.innerHeight);
      }
  
      this.scrolling = false;
    };
  
    function updateScale(element, value) { // apply new scale value
      element.visibleFigure.style.transform = 'scale('+value+')';
      element.visibleFigure.style.msTransform = 'scale('+value+')';
    };
  
    function updateOpacity(element, value) { // update layer opacity
      element.element.style.setProperty('--immerse-section-tr-opacity', value);
    };
  
    function immerseSectionTrCallback(entries) { // intersectionObserver callback
      if(entries[0].isIntersecting) {
        if(this.scrollingFn) return; // listener for scroll event already added
        immerseSectionTrScrollEvent(this);
      } else {
        if(!this.scrollingFn) return; // listener for scroll event already removed
        window.removeEventListener('scroll', this.scrollingFn);
        this.scrollingFn = false;
      }
    };
  
    function immerseSectionTrScrollEvent(element) { // listen to scroll when asset element is inside the viewport
      element.scrollingFn = immerseSectionTrScrolling.bind(element);
      window.addEventListener('scroll', element.scrollingFn);
    };
  
    function immerseSectionTrScrolling() { // update asset scale on scroll
      if(this.scrolling) return;
      this.scrolling = true;
      window.requestAnimationFrame(setScaleValue.bind(this));
    };
  
    function initContainer(element) {
      // add a padding to the container to fix the collapsing-margin issue
      if(parseInt(window.getComputedStyle(element.element).getPropertyValue('padding-top')) == 0) element.element.style.paddingTop = '1px';
    };
  
    function checkEffectActive(element) { //check if effect needs to be activated
      element.active = true;
      if(element.visibleFigure.offsetHeight >= window.innerHeight) element.active = false;
      if( window.innerHeight - element.visibleFigure.offsetHeight >= 600) element.active = false;
    };
  
    //initialize the ImmerseSectionTr objects
    var immerseSections = document.getElementsByClassName('js-immerse-section-tr'),
      reducedMotion = Util.osHasReducedMotion(),
      intObserverSupported = ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype);
  
    if(immerseSections.length < 1 ) return;
    if( !reducedMotion && intObserverSupported) {
      var immerseSectionsArray = [];
      for( var i = 0; i < immerseSections.length; i++) {
        (function(i){immerseSectionsArray.push(new ImmerseSectionTr(immerseSections[i]));})(i);
      }
  
      if(immerseSectionsArray.length > 0) {
        var resizingId = false,
          customEvent = new CustomEvent('update-immerse-section');
        
        window.addEventListener('resize', function() {
          clearTimeout(resizingId);
          resizingId = setTimeout(doneResizing, 500);
        });
  
        function doneResizing() {
          for( var i = 0; i < immerseSectionsArray.length; i++) {
            (function(i){immerseSectionsArray[i].element.dispatchEvent(customEvent)})(i);
          };
        };
      };
    } else { // effect deactivated
      for( var i = 0; i < immerseSections.length; i++) Util.addClass(immerseSections[i], 'immerse-section-tr--disabled');
    }
  }());